<mh-section-followup-properties [productId]="2"></mh-section-followup-properties>